<div [class]="'layer-item ' + (innerItemClass ?? '')">
  <wlm-icon
    *ngIf="isDragAndDropEnabled"
    class="vertical-center-icon drag-icon"
    [icon]="'drag_and_drops'"
  ></wlm-icon>
  <wlm-svg
    *ngIf="layer.iconPath"
    class="svg-icon svg-icon-margin"
    [style.height]="iconDefaultSize + 'px'"
    [style.width]="iconDefaultSize + 'px'"
    [width]="iconDefaultSize"
    [height]="iconDefaultSize"
    [path]="layer.iconPath"
  ></wlm-svg>
  <div class="layer-name">
    {{
      layer.layerDefinition?.isThematic
        ? layer.layerStyle?.styleName || layer.layerName
        : layer.layerName
    }}
  </div>
  <button
    mat-icon-button
    color="primary"
    class="filter-button"
    onclick="this.blur()"
    *ngIf="!layerIsVisible"
    (click)="hideLayer($event)"
  >
    <wlm-icon class="visibility-button" icon="visibility_off"></wlm-icon>
  </button>
  <button
    mat-icon-button
    color="primary"
    class="filter-button"
    onclick="this.blur()"
    *ngIf="layerIsVisible"
    (click)="showLayer($event)"
  >
    <wlm-icon
      class="visibility-button"
      icon="visibility"
      [color]="WtrColors.SuccessColor"
    ></wlm-icon>
  </button>
  <button
    *ngIf="isThematic && canConfigure"
    mat-icon-button
    color="black"
    class="filter-button"
    onclick="this.blur()"
    (click)="selectedLayer($event)"
  >
    <wlm-icon icon="tune" [color]="WtrColors.SuccessColor"></wlm-icon>
  </button>
  <button
    *ngIf="isThematic && canConfigure"
    mat-icon-button
    color="black"
    class="filter-button"
    onclick="this.blur()"
    (click)="onDeletedLayer($event)"
  >
    <wlm-icon icon="delete" [color]="WtrColors.SuccessColor"></wlm-icon>
  </button>
</div>
